export enum TipoPrestadorId {
    Comerciante = 1,
    NoComerciante = 2, 
    SinClasificar = 3
}
